export default __webpack_public_path__ + "static/shadow-dont-cf05f90d6f1d62dc44299445106bac71.png";